const StyleConstants = {
	bootstrapSuccessClassName: 'success',
	bootstrapFailureClassName: 'danger',
}

export default StyleConstants;